import { BuildGooglePlacesAutocompleteRequestArgs } from '@marketplace-web/shipping/google-places-data'

import { buildGooglePlacesAutocompleteRequest } from './buildGooglePlacesAutocompleteRequest'

export const getGooglePlacePredictions = (
  options: BuildGooglePlacesAutocompleteRequestArgs,
): Promise<Array<google.maps.places.AutocompletePrediction> | null> =>
  new Promise(resolve => {
    if (typeof window?.google?.maps === 'undefined') resolve(null)
    if (!options.value) resolve(null)

    try {
      new window.google.maps.places.AutocompleteService().getPlacePredictions(
        buildGooglePlacesAutocompleteRequest(options),
        (predictions, status) => {
          if (status !== window.google.maps.places.PlacesServiceStatus.OK) return

          resolve(predictions)
        },
      )
    } catch {
      resolve(null)
    }
  })
